import { FC } from 'react';

type Props = {
	className?: string;
};

const FireIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M9.99988 17.9997C13.3135 17.9997 15.9998 15.3134 15.9998 11.9998C15.9998 11.1998 15.9998 9.59984 14.3998 7.59989C14.3998 7.59989 14.3201 9.88272 12.7408 9.55249C10.1864 9.01842 13.4839 4.00233 8.7999 2C8.7999 5.99992 4 7.19989 4 11.9998C4 15.3134 6.68623 17.9997 9.99988 17.9997Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
			<path
				d='M9.99916 15.6005C11.5455 15.6005 12.7991 13.9887 12.7991 12.0005C10.2392 12.9605 9.33254 10.75 9.19918 9.19971C8.04261 9.64226 7.19922 11.4601 7.19922 12.3996C7.19922 14.3878 8.45279 15.6005 9.99916 15.6005Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default FireIcon;
